import React from 'react';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import { useNavigate } from 'react-router-dom';
import { advanceFiguresAtom } from '../../recoil';
import { PRODUCT_CONFIG, ACTION_ENUM } from '../../helpers/productConfig';
import { postBusinessReapply } from '../../api/vodaLend';
import { useLoader } from '../Loader/useLoader';
import { StaticRoutes } from '../../Router';
import styles from './btaAdvanceBanner.module.css';

const PRODUCT_KEY = 'LLL#BTA';

const shouldShowBanner = ({ applicationStatus, isReadvanceEligible }) => {
  const status = applicationStatus.toLowerCase();
  if (status === 'closed') {
    return true;
  }
  return isReadvanceEligible === true;
};

export const BTAAdvanceBanner = ({ applicationId, applicationStatus, businessId }) => {
  const data = useRecoilValue(advanceFiguresAtom(applicationId));
  const navigate = useNavigate();
  const [openLoader, closeLoader] = useLoader();

  if (!data) { return null; };

  const normalizedStatus = applicationStatus.toUpperCase();
  const ctaConfig = PRODUCT_CONFIG[PRODUCT_KEY]?.cta?.[normalizedStatus];
  const ctaLabel = ctaConfig?.label ?? 'Request a callback';
  const showBanner = shouldShowBanner({ applicationStatus, isReadvanceEligible: data.isReadvanceEligible });

  if (!showBanner) { return null; };

  const handleCtaClick = async () => {
    if (ctaConfig?.action === ACTION_ENUM.RE_APPLY_JOURNEY) {
      if (ctaLabel === 'Request a callback') {
        openLoader();
        try {
          await postBusinessReapply(businessId, { partnerCode: 'LLL', productCode: 'BTA' });
        } finally {
          closeLoader();
        }
      } else {
        navigate(StaticRoutes.FundingApplicationDetails);
      }
    }
  };

  return (
    <div className={styles.banner}>
      <span className={styles.heading}>Need additional funds?</span>
      <span className={styles.description}>
        {normalizedStatus === 'CLOSED'
          ? 'You have paid off enough of your Fixed Term Funding.'
          : 'Request a callback and we’ll contact you within 24 hours to get you started.'}
      </span>
      <button className={styles.cta} onClick={handleCtaClick} type='button'>
        {ctaLabel}
      </button>
      <span className={styles.disclaimer}>
        Subject to credit vetting and approval. Ts &amp; Cs apply.
      </span>
    </div>
  );
};

BTAAdvanceBanner.propTypes = {
  applicationId: PropTypes.string.isRequired,
  applicationStatus: PropTypes.string.isRequired,
  businessId: PropTypes.string.isRequired
};
